import { render, staticRenderFns } from "./yanshou.vue?vue&type=template&id=1198a458&scoped=true&"
import script from "./yanshou.vue?vue&type=script&lang=js&"
export * from "./yanshou.vue?vue&type=script&lang=js&"
import style0 from "./yanshou.vue?vue&type=style&index=0&id=1198a458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198a458",
  null
  
)

export default component.exports